import { AuthConfig } from 'angular-oauth2-oidc';

import { environment } from 'src/environments/environment';

export const authCodeFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.SSO_URL,
  clientId: environment.CLIENT_ID,
  responseType: 'code',
  dummyClientSecret: environment.CLIENT_SECRET,
  redirectUri: environment.WEB_REDIRECT_URL,
  scope: 'openid profile email offline_access',
  timeoutFactor: 0.2,
  clearHashAfterLogin: false,
  oidc: true,
};
